const NotFound = () =>{
    return (
        <div className="flex h-screen w-screen justify-center items-center">
            <h1>404 , Not Found!</h1>
        </div>
    )
}

export default NotFound;